import React, { useEffect, useState } from "react";
import useResolverPromise from "hooks/useResolvePromise";
import PropTypes from "prop-types";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import ObjectOptions from "./ObjectOptions";

const PromiseOptions = ({ options }) => {
  const [selectOptions, updateSelectOptions] = useState();
  const { loading, data: optionsData, error } = useResolverPromise(options);
  const { translate: t } = useLanguageProvider();

  useEffect(() => {
    if (optionsData) {
      updateSelectOptions(optionsData);
    }
    return () => {
      updateSelectOptions([]);
    };
  }, [optionsData]);

  const mappedOptions = selectOptions?.map((option, i) => (
    <option key={`option.value_${i}`} value={option.value} data-testid={option.value}>
      {t(option.label)}
    </option>
  ));

  return error || loading || mappedOptions;
};

ObjectOptions.propTypes = {
  options: PropTypes.instanceOf(Promise),
};

export default PromiseOptions;
